import { render } from "./ModalForm.vue?vue&type=template&id=29bd5ba3"
import script from "./ModalForm.vue?vue&type=script&lang=js"
export * from "./ModalForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"wp-content/themes/nns-template/vue/components/ModalForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "29bd5ba3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('29bd5ba3', __exports__)) {
    api.reload('29bd5ba3', __exports__)
  }
  
  module.hot.accept("./ModalForm.vue?vue&type=template&id=29bd5ba3", () => {
    api.rerender('29bd5ba3', render)
  })

}


export default __exports__